import React from "react";

export default function DisplayProgress({ completed, total }) {
    const percentage = total > 0 ? (completed / total) * 100 : 0;
    return (
        <div className="progressContainer">
            <div id="progressText">
                {completed} / {total}
            </div>
            <div id="progress">
                <div id="progressBar" style={{ width: `${percentage}%` }}></div>
            </div>
        </div>
    );
}